import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./PrivacyFeatures.css";
import Footer from "../../Home_Page_WLog/Footer/Footer";
import LoginHeader from "../../Home_Page_WLog/LoginHeader/LoginHeader";
import {
  ShieldCheck,
  MessageCircle,
  Database,
  Image,
  Ban,
  KeyRound,
  Eye,
  SearchCheck,
  FileText,
  Settings,
  CheckCircle2,
} from "lucide-react";

const Privacy_Features = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const featuresData = [
    {
      number: "01",
      icon: <ShieldCheck size={20} />,
      title: "Profile Verification",
      text: "Every profile is carefully verified to reduce fake accounts and ensure genuine matrimonial connections.",
    },
    {
      number: "02",
      icon: <MessageCircle size={20} />,
      title: "Secure Messaging",
      text: "All chats and communications are encrypted to protect your privacy and prevent unauthorized access.",
    },
    {
      number: "03",
      icon: <Database size={20} />,
      title: "Data Protection",
      text: "Your personal information is stored securely and never shared without your consent.",
    },
    {
      number: "04",
      icon: <Image size={20} />,
      title: "Photo Privacy",
      text: "Control who can view your pictures by adjusting your privacy settings anytime.",
    },
    {
      number: "05",
      icon: <Ban size={20} />,
      title: "Report & Block",
      text: "Instantly block or report suspicious users to keep your experience safe and stress-free.",
    },
    {
      number: "06",
      icon: <KeyRound size={20} />,
      title: "OTP & Login Security",
      text: "Multi-layer authentication, including OTP verification, helps prevent unauthorized logins.",
    },
    {
      number: "07",
      icon: <ShieldCheck size={20} />,
      title: "No Data Selling",
      text: "We strictly do not sell, rent, or misuse your personal information for any third-party marketing.",
    },
    {
      number: "08",
      icon: <SearchCheck size={20} />,
      title: "Fraud Monitoring",
      text: "Our team actively monitors fraudulent activities to ensure a trusted matchmaking environment.",
    },
    {
      number: "09",
      icon: <FileText size={20} />,
      title: "Transparent Policies",
      text: "All our privacy rules and guidelines are clearly defined for your complete transparency.",
    },
    {
      number: "10",
      icon: <Settings size={20} />,
      title: "User Control",
      text: "You have full control over editing, updating, or deleting your account anytime you wish.",
    },
  ];

  return (
    <>
      <LoginHeader />

      <div className="pf-page">
        {/* HERO */}
        <section className="pf-hero">
          <div className="pf-hero-overlay"></div>

          <div className="pf-floating-wrap">
            {["🔒", "💖", "🛡️", "✨", "💍", "❤️", "🔐", "🌸"].map((item, index) => (
              <span key={index} className={`pf-float pf-float-${index}`}>
                {item}
              </span>
            ))}
          </div>

          <div className="pf-hero-content" data-aos="fade-up">
            <div className="pf-badge">
              <ShieldCheck size={15} />
              Privacy & Safety First
            </div>

            <h1 className="pf-main-title">
              Privacy <span>Features</span>
            </h1>

            <p className="pf-subtitle">
              Explore the essential privacy and safety features that make Community
              Rishtey a secure, respectful, and trustworthy matrimonial platform.
            </p>

            <div className="pf-top-pills">
              <span>🔒 Secure Platform</span>
              <span>✅ Verified Users</span>
              <span>🛡️ Privacy Protected</span>
            </div>
          </div>
        </section>

        {/* CONTENT */}
        <section className="pf-container">
          <div className="pf-header" data-aos="fade-up">
            <span className="pf-section-badge">Community Rishtey Protection Layer</span>
            <h2 className="pf-title">Designed to Keep You Safe & In Control</h2>
            <p className="pf-description">
              Our platform is built with strong privacy controls, secure communication,
              and transparency to ensure your matrimonial journey remains safe and trusted.
            </p>
          </div>

          <div className="pf-grid">
            {featuresData.map((item, index) => (
              <div
                key={index}
                className="pf-card"
                data-aos="zoom-in-up"
                data-aos-delay={index * 60}
              >
                <div className="pf-card-glow"></div>

                <div className="pf-card-top">
                  <div className="pf-icon-wrap">{item.icon}</div>
                  <div className="pf-number">{item.number}</div>
                </div>

                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            ))}
          </div>

          <div className="pf-final-note" data-aos="fade-up">
            <div className="pf-final-icon">
              <CheckCircle2 size={22} />
            </div>
            <div>
              <h4>Privacy You Can Trust</h4>
              <p>
                At Community Rishtey, your privacy and trust come first. We are
                committed to providing a safe, secure, and respectful matrimonial
                experience for everyone.
              </p>
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default Privacy_Features;